export default "__VITE_ASSET__koQxzkrD__"